import { configureStore } from '@reduxjs/toolkit';
import pageReducer from './slices/pageSlice';
import formNameReducer from "./slices/formNameSlice";
import ultrasReducer from "./slices/ultrasSlice";
import selectedPromoIDReducer from './slices/selectedPromoIDSlice'
import promoFormReducer from "./slices/promoFormSlice";
import taskReducer from "./slices/taskSlice";
import fullDrawerReducer from "./slices/fullDrawerSlice";
import positionsSlice from "./slices/positionsSlice";

export const store = configureStore({
    reducer: {
        page: pageReducer,
        fullDrawer: fullDrawerReducer,
        formName: formNameReducer,
        ultras: ultrasReducer,
        selectedPromoID: selectedPromoIDReducer,
        promoForm: promoFormReducer,
        tasks: taskReducer,
        positions:positionsSlice
    },
});
